import React from 'react';
import { withTranslation } from 'react-i18next';
import {
    Card,
    DaButton,
    ButtonGroup,
    Text,
    Title,
} from '@paygreen/paygreen-ui';
import { IsBigDesktop } from '../../../utils/tools';

const CharityCard = ({ t }) => (
    <Card
        blockWidth={IsBigDesktop() ? 'sm' : 'none'}
        hasBackground={true}
        colorPallet="theme"
        colorTheme="quaternary"
        paddingBottom="sm"
        paddingTop="sm"
        paddingLateral="sm"
        shadowSize="none"
        data-cy="charitykit-card"
    >
        <Title
            colorPallet="theme"
            colorTheme="quaternary"
            textSize="base"
            marginBottom="xs"
        >
            {t('user.billing.charityCard.title')}
        </Title>

        <Text colorPallet="theme" colorTheme="quaternary" textSize="sm">
            {t('user.billing.charityCard.charityText')}
        </Text>

        <ButtonGroup marginTop="sm">
            <a
                href="https://paygreen.io/arrondi-en-ligne/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <DaButton gradient="theme" colorTheme="quaternary">
                    {t('user.billing.charityCard.charityLink')}
                </DaButton>
            </a>
        </ButtonGroup>
    </Card>
);

export default withTranslation('common')(CharityCard);
